module.exports = __webpack_public_path__ + "static/media/logo_toolbar.d21de407.png";